import React, { Component } from "react";
import { Button, Divider, List, message } from "antd";
import { stringify } from "qs";
import FilesUpload from "nbugs-files-upload";
import router from "umi/router";
// import { connect } from 'dva';
import { ENV } from "@/services/utils";
import styles from "./Content.less";

const { Item } = List;

// @connect(({ self }) => ({
//   annexGroupId: self.annexGroupId,
//   fileCount: self.fileCount,
// }))
class Content extends Component {
  state = {};

  handleJump = () => {
    const { currentProjectId, allowEdit } = this.props;
    if(allowEdit) {
      router.push(
        `/supervision/norm/self/my/tree?${stringify({
          currentProjectId
        })}`
      );
    } else {
      message.error('不在评估时间内')
    }
  };

  handleFileGroupId = (fileId, length) => {
    const { dispatch, currentProjectId } = this.props;
    dispatch({
      type: "self/uploadAddAppenix",
      payload: {
        appendix: fileId,
        projectId: currentProjectId
      }
    });
  };

  render() {
    const { endTime, progress, appendix } = this.props;
    const fillNum = progress.split("/")[0];
    return (
      <div className={styles.content}>
        <div className="title-wrap">
          <Divider orientation="left">自评填报情况</Divider>:
        </div>
        <div className="detail-wrap">
          <Item>
            <span className="itemName">填报结束时间</span>:
            <span style={{ marginLeft: 16 }}>{endTime}</span>
          </Item>
          <Item>
            <span className="itemName">填报进度</span>:
            <div style={{marginLeft:16}}>
              <Button onClick={this.handleJump}>自评填报</Button>
              <span style={{marginLeft:12, color:'#1785ec'}}>{progress}</span>
            </div>
          </Item>
          {fillNum !== "0" && (
            <Item>
              <span className="itemName">自评报告</span>:
              <div className="fieldsUpload" style={{ marginLeft: 16 }}>
                <FilesUpload
                  edit={0}
                  type="pc"
                  APIEnv={ENV}
                  callback={this.handleFileGroupId}
                  groupId={appendix}
                  previewUrl={`//${window.location.hostname}/v2/preview/file`}
                />
              </div>
            </Item>
          )}
        </div>
      </div>
    );
  }
}

export default Content;
